const EmployeeActionTypes = {
  GET_EMPLOYEES_START: 'GET_EMPLOYEES_START',
  GET_EMPLOYEES_SUCCESS: 'GET_EMPLOYEES_SUCCESS',
  GET_EMPLOYEES_FAILURE: 'GET_EMPLOYEES_FAILURE',
};

export default EmployeeActionTypes;
